import styled from "styled-components";

export const Container = styled.div`
  max-width: 1440px;
  padding: 0px 80px;
  margin: 0px auto;
  display: flex;
  align-items: center;
  gap: 1em;
  justify-content: space-between;
  @media screen and (max-width: 1024px) {
    padding: 0px 32px;
  }
  @media screen and (max-width: 768px) {
    flex-flow: column;
  }
`;

export const Column2 = styled.div`
  flex-basis: calc(0.5 * 100%);
  .collectionImg {
  }
`;

export const Column = styled.div`
  width: calc(100% / ${(props) => props.divide} - 25px);
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
  .collectionimg {
    height: 319px;
    border-radius: 20px;
  }
`;
export const Section = styled.section`
  width: 100%;
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.bg};
  @media screen and (max-width: 1024px) {
    padding: ${(props) => props.mpadding};
  }
`;
export const SectionTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
  margin-bottom: 3em;
  @media screen and (max-width: 768px) {
    margin-bottom: 1.5em;
  }
  h2 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 2em;
    color: ${(props) => props.color};
    @media screen and (max-width: 768px) {
      font-family: Poppins;
      font-size: 24px;
      font-weight: 600;
      line-height: 1em;
      letter-spacing: 0em;
      text-align: center;
    }
  }
  p {
    text-align: center;
    //styleName: Body 1 ;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1d2646;
    max-width: 768px;
    @media screen and (max-width: 768px) {
      width: 100%;
      font-family: Poppins;
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: center;
    }
  }
`;
